export default "__VITE_ASSET__CJxEDLfI__"